module.exports = __webpack_public_path__ + "img/step_3-3.f7b530cc.png";